export default {
    dev: {
        companyId: 'Traderr',
        apiKey: 'Eg0ywpDWeT0DKgi2TIqvtgEjhEF3LULYY',
        test: true
    },
    prod: {
        companyId: 'aktiedysten.dk',
        apiKey: 'AtZcC1yjOEoY9vK5kXlr3kHNMvpyi/Qqs',
        test: false
    }
}


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Payment/PaymentConfigs.js